<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="eSB"
            description="Indicadores de Saúde Bucal na APS"
            url="/indicadores-aps"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import PrimeiraConsultaProgramada from '@/components/icons/IndicadoresEsb/Estrategicos/PrimeiraConsultaProgramada'
import TratamentosConcluidos from '@/components/icons/IndicadoresEsb/Estrategicos/TratamentosConcluidos'
import Exodontias from '@/components/icons/IndicadoresEsb/Estrategicos/Exodontias'
import EscovacaoSupervisionada from '@/components/icons/IndicadoresEsb/Estrategicos/EscovacaoSupervisionada'
import Prevencao from '@/components/icons/IndicadoresEsb/Ampliados/Prevencao'
import TratamentosRestauradoresArt from '@/components/icons/IndicadoresEsb/Ampliados/TratamentosRestauradoresArt'
import ConsultasPreNatal from '@/components/icons/IndicadoresAps/PreNatal/ConsultasPreNatal.vue'

export default {
  name: 'SaudeBucal',
  metaInfo: {
    title: 'eSB',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    PrimeiraConsultaProgramada,
    TratamentosConcluidos,
    Exodontias,
    EscovacaoSupervisionada,
    Prevencao,
    TratamentosRestauradoresArt,
    ConsultasPreNatal,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.indicadores_esb
      ) {
        const dataClone = [...this.$store.state.permissoes.indicadores_esb]
        return dataClone.sort((a, b) => a.ordem - b.ordem)
      }
      return []
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
